/**
 * This file exports constants consumed by parts of the application that only understands commonjs.
 * One example is the `next.config.js` file.
 */

if (!process.env.NEXT_PUBLIC_APP_NAME) {
  throw new Error("NEXT_PUBLIC_APP_NAME environment variable is missing");
}

module.exports = {
  APP_NAME: process.env.NEXT_PUBLIC_APP_NAME,
  WP_ORIGIN: process.env.NEXT_PUBLIC_WP_ORIGIN,
  SENTRY_CLIENT_SAMPLE_RATE: process.env.NEXT_PUBLIC_SENTRY_CLIENT_SAMPLE_RATE
    ? Number.parseFloat(process.env.NEXT_PUBLIC_SENTRY_CLIENT_SAMPLE_RATE)
    : 1.0,
  SENTRY_SERVER_SAMPLE_RATE: process.env.NEXT_PUBLIC_SENTRY_SERVER_SAMPLE_RATE
    ? Number.parseFloat(process.env.NEXT_PUBLIC_SENTRY_SERVER_SAMPLE_RATE)
    : 1.0,
};
